



















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ResetSubPassLogBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly historyPage!: number;
}
